import { useState, useEffect, useContext } from "react";
import { useQuery } from "@apollo/client";
import { AuthContext } from "../../Context/AuthContext";
import {
  GET_CAPITAL_PROVINCE,
  GET_COMMUNE_BY_DISTRICT,
  GET_CANDIDATE_FOR_SELECT,
  GET_COUNCIL_POSITION_FOR_SELECT,
  GET_DISTRICT_BY_PROVINCE,
  GET_INSTITUTE_OR_UNIVERSITY_FOR_SELECT,
  GET_MAJORS_FOR_SELECT,
  GET_MEMBER_FOR_SELECT,
  GET_PARTY_BY_MANDATE,
  GET_PARTY_FOR_SELECT,
  GET_VILLAGE_BY_COMMUNE,
  GET_CANDIDATE_IN_MANDATE_FOR_SELECT,
  GET_MANDATE_FOR_COPY_CADIDATE,
  GET_PARTY_FOR_COPY_CADIDATE,
  GET_REASON_OF_LOSS_MEMBER_FOR_SELECT,
  GET_USER_FOR_SELECT,
  GET_PROVINCAIL_COUNCIL_IN_MANDATE_FOR_SELECT,
  GET_SECRETARY_IN_MANDATE_FOR_SELECT,
  GET_WORK_GROUP_FOR_SELECT
} from "../../Schema/SelectSchema";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";

import {
  Stack,
  TextField,
  Typography,
  IconButton,
  Autocomplete,
} from "@mui/material";
import PartyForm from "../Party/PartyForm";
import CouncilPositionsForm from "../CouncilPositions/Form/CouncilPositionsForm";
import MemberForm from "../Member/Form/MemberForm";
import MajorForm from "../Major/MajorForm";
import InstituteOrUniversityForm from "../InstituteOrUniversity/InstituteOrUniversityForm";
import CandidateMemberForm from "../Candidate/CandidateMemberForm";
import CreateNewSecretary from "../Secretarait/CreateNewSecretary";
import { getKhmerNumber } from "../../Function/DynamicFn";

export const SelectMember = ({
  className,
  onChange,
  buttonAdd = true,
  value = { id: "", title: "" },
  role,
  helperText,
  error,
}) => {
  // Change Language
  const { t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_MEMBER_FOR_SELECT, {
    variables: {
      role: role,
    },
    onCompleted: ({ getMemberForSelect }) => {
      const data = getMemberForSelect?.map((e) => ({
        id: e?._id,
        title: e?.lastNameKh + " " + e?.firstNameKh,
      }));
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
      >
        <Typography className={t("class-name-field-title")}>
          {t("thead_member")}
        </Typography>

        {buttonAdd && (
          <IconButton sx={{ padding: 0.5 }} onClick={handleOpen}>
            <AddBoxOutlinedIcon
              fontSize="small"
              sx={{ color: "green", cursor: "pointer" }}
            />
          </IconButton>
        )}

        {open && (
          <MemberForm
            open={open}
            onChange={onChange}
            hideBackdrop={true}
            setRefetch={refetch}
            dialogTitle={"Create"}
            handleClose={handleClose}
          />
        )}
      </Stack>
      <Autocomplete
        fullWidth
        size="small"
        options={selectOptions}
        className={className}
        value={value}
        onChange={(_event, val) => onChange(val)}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={() => true}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("thead_select")}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </Stack>
  );
};

export const SelectCandidateInMandate = ({
  className,
  onChange,
  disabled = false,
  buttonAdd = true,
  value = { id: "", title: "" },
  helperText,
  error,
}) => {
  // Change Language
 
  const { t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_CANDIDATE_IN_MANDATE_FOR_SELECT, {
    onCompleted: ({ getCandidateInMandateForSelect }) => {
      // console.log("getCandidateInMandateForSelect :", getCandidateInMandateForSelect)
      const data = getCandidateInMandateForSelect?.map((e) => ({
        id: e?._id,
        title: e?.lastNameKh + " " + e?.firstNameKh,
        numberOrder: e?.numberOrder,
        candidateId: e?.candidateId,
        party: { id: e?.party?._id || "", title: e?.party?.partyName || "" },
      }));
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
      >
        <Typography className={t("class-name-field-title")}>
          {t("thead_member")}
        </Typography>

        {buttonAdd && (
          <IconButton sx={{ padding: 0.5 }} onClick={handleOpen}>
            <AddBoxOutlinedIcon
              fontSize="small"
              sx={{ color: "green", cursor: "pointer" }}
            />
          </IconButton>
        )}

        {open && (
          <MemberForm
            open={open}
            onChange={onChange}
            hideBackdrop={true}
            setRefetch={refetch}
            dialogTitle={"Create"}
            handleClose={handleClose}
          />
        )}
      </Stack>
      <Autocomplete
        disabled={disabled}
        fullWidth
        size="small"
        options={selectOptions}
        className={className}
        value={value}
        onChange={(_event, val) => onChange(val)}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={() => true}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("thead_select")}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </Stack>
  );
};


export const SelectUser = ({
  quickCreateName,
  role,
  className,
  onChange,
  buttonAdd = true,
  value = { id: "", title: "" },
  helperText,
  error,
}) => {
  // Change Language

  const { t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_USER_FOR_SELECT, {
    variables:{
      role
    },
    onCompleted: ({ selectUser }) => {
      const data = selectUser?.map((e) => ({
        id: e?._id,
        title: e?.lastNameKh + " " + e?.firstNameKh,
      }));
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
      >
        <Typography className={t("class-name-field-title")}>
          {t("thead_member")}
        </Typography>

        {buttonAdd && (
          <IconButton sx={{ padding: 0.5 }} onClick={handleOpen}>
            <AddBoxOutlinedIcon
              fontSize="small"
              sx={{ color: "green", cursor: "pointer" }}
            />
          </IconButton>
        )}

        {open && quickCreateName === "Secretary" && (
          <CreateNewSecretary
            open={open}
            onChange={onChange}
            hideBackdrop={true}
            setRefetch={refetch}
            dialogTitle={"Create"}
            handleClose={handleClose}
          />
        )}
      </Stack>
      <Autocomplete
        fullWidth
        size="small"
        options={selectOptions}
        className={className}
        value={value}
        onChange={(_event, val) => onChange(val)}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={() => true}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("thead_select")}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </Stack>
  );
};

export const SelectCandidate = ({
  className,
  onChange,
  buttonAdd = true,
  value = { id: "", title: "" },
  helperText,
  error,
}) => {
  // Change Language
  const { t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_CANDIDATE_FOR_SELECT, {
    onCompleted: ({ getCandidateForSelect }) => {
      const data = getCandidateForSelect?.map((e) => ({
        id: e?._id,
        title: e?.lastNameKh + " " + e?.firstNameKh,
      }));
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
      >
        <Typography className={t("class-name-field-title")}>
          {t("thead_member")}
        </Typography>

        {buttonAdd && (
          <IconButton sx={{ padding: 0.5 }} onClick={handleOpen}>
            <AddBoxOutlinedIcon
              fontSize="small"
              sx={{ color: "green", cursor: "pointer" }}
            />
          </IconButton>
        )}

        {open && (
          <CandidateMemberForm
            open={open}
            onChange={onChange}
            hideBackdrop={true}
            setRefetch={refetch}
            dialogTitle={"Create"}
            handleClose={handleClose}
          />
        )}
      </Stack>
      <Autocomplete
        fullWidth
        size="small"
        options={selectOptions}
        className={className}
        value={value}
        onChange={(_event, val) => onChange(val)}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={() => true}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("thead_select")}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </Stack>
  );
};

export const SelectMandateForCopyCadidate = ({
  className,
  onChange,
  value = { id: "", title: "" },
  helperText,
  error,
}) => {

  // Change Language
  const { t, language } = useContext(AuthContext);
  const level = language === "kh" ? "ទី" : "";
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_MANDATE_FOR_COPY_CADIDATE, {
    onCompleted: ({ getMandateForCopyCadidate }) => {
      const data = getMandateForCopyCadidate?.map((e) => {
        const mandate = language === "kh" ? getKhmerNumber(parseFloat(e?.mandateName)) : e?.mandateName;
        return ({
          id: e?._id,
          title: t("thead_mandate") + level + mandate,
        })
      });
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value]);

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={selectOptions}
      className={className}
      value={value}
      onChange={(_event, val) => onChange(val)}
      getOptionLabel={(option) => option.title || ""}
      isOptionEqualToValue={() => true}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={t("thead_select")}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};



export const SelectInstituteOrUniversity = ({
  className,
  onChange,
  buttonAdd = true,
  value = { id: "", title: "" },
  role,
  helperText,
  error,
}) => {
  // Change Language
  const { t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_INSTITUTE_OR_UNIVERSITY_FOR_SELECT, {
    variables: {
      role: role,
    },
    onCompleted: ({ getInstituteOrUniversityForSelect }) => {
      const data = getInstituteOrUniversityForSelect?.map((e) => ({
        id: e?._id,
        title: e?.nameKh,
      }));
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
      >
        <Typography className={t("class-name-field-title")}>
          {t("thead_institute_or_university")}
        </Typography>

        {buttonAdd && (
          <IconButton sx={{ padding: 0.5 }} onClick={handleOpen}>
            <AddBoxOutlinedIcon
              fontSize="small"
              sx={{ color: "green", cursor: "pointer" }}
            />
          </IconButton>
        )}

        {open && (
          <InstituteOrUniversityForm
            open={open}
            hideBackdrop={true}
            setRefetch={refetch}
            dialogTitle={"Create"}
            handleClose={handleClose}
          />
        )}
      </Stack>
      <Autocomplete
        fullWidth
        size="small"
        options={selectOptions}
        className={className}
        value={value}
        onChange={(_event, val) => onChange(val)}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={() => true}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("thead_select")}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </Stack>
  );
};

export const SelectMajors = ({
  className,
  onChange,
  buttonAdd = true,
  value = { id: "", title: "" },
  role,
  helperText,
  error,
}) => {
  // Change Language
  const { t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_MAJORS_FOR_SELECT, {
    variables: {
      role: role,
    },
    onCompleted: ({ getMajorsForSelect }) => {
      const data = getMajorsForSelect?.map((e) => ({
        id: e?._id,
        title: e?.majorsNameKh,
      }));
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
      >
        <Typography className={t("class-name-field-title")}>
          {t("thead_major")}
        </Typography>

        {buttonAdd && (
          <IconButton sx={{ padding: 0.5 }} onClick={handleOpen}>
            <AddBoxOutlinedIcon
              fontSize="small"
              sx={{ color: "green", cursor: "pointer" }}
            />
          </IconButton>
        )}

        {open && (
          <MajorForm
            open={open}
            hideBackdrop={true}
            setRefetch={refetch}
            dialogTitle={"Create"}
            handleClose={handleClose}
          />
        )}
      </Stack>
      <Autocomplete
        fullWidth
        size="small"
        options={selectOptions}
        className={className}
        value={value}
        onChange={(_event, val) => onChange(val)}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={() => true}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("thead_select")}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </Stack>
  );
};

export const SelectCouncilPositions = ({
  className,
  onChange,
  dialogTitle,
  buttonAdd = true,
  value = { id: "", title: "" },
  helperText,
  error,
}) => {
  // Change Language
  const { language, t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_COUNCIL_POSITION_FOR_SELECT, {
    onCompleted: ({ getCouncilPositionsForSelect }) => {
      const data = getCouncilPositionsForSelect?.map((e) => ({
        id: e?._id,

        title: language === "en" ? e?.positionsNameEng : e?.positionsNameKh,
      }));

      const defaultPosition = getCouncilPositionsForSelect.find(
        (e) => e?.isDefault
      );
      if (dialogTitle === "Create" && defaultPosition?.isDefault) {
        onChange({
          id: defaultPosition?._id,
          title:
            language === "en"
              ? defaultPosition?.positionsNameEng
              : defaultPosition?.positionsNameKh,
        });
      }
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
      >
        <Typography className={t("class-name-field-title")}>
          {t("thead_council_positions")}
        </Typography>

        {buttonAdd && (
          <IconButton sx={{ padding: 0.5 }} onClick={handleOpen}>
            <AddBoxOutlinedIcon
              fontSize="small"
              sx={{ color: "green", cursor: "pointer" }}
            />
          </IconButton>
        )}

        {open && (
          <CouncilPositionsForm
            open={open}
            onChange={onChange}
            hideBackdrop={true}
            setRefetch={refetch}
            dialogTitle={"Create"}
            handleClose={handleClose}
          />
        )}
      </Stack>
      <Autocomplete
        fullWidth
        size="small"
        options={selectOptions}
        className={className}
        value={value}
        onChange={(_event, val) => onChange(val)}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={() => true}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("thead_select")}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </Stack>
  );
};

export const SelectParty = ({
  className,
  onChange,
  buttonAdd = true,
  disabled = false,
  dialogTitle,
  value = { id: "", title: "" },
  helperText,
  error,
}) => {
  // Change Language
  const { language, t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_PARTY_BY_MANDATE, {
    onCompleted: ({ getPartyByMandate }) => {
      const data = getPartyByMandate?.map((e) => ({
        id: e?._id,
        title: e?.partyName,
      }));

      const defaultPosition = getPartyByMandate.find((e) => e?.isDefault);
      if (dialogTitle === "Create" && defaultPosition?.isDefault) {
        onChange({
          id: defaultPosition?._id,
          title: defaultPosition?.partyName,
        });
      }
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack>
      {buttonAdd && (
        <Stack
          direction="row"
          alignItems="flex-end"
          justifyContent="space-between"
        >
          <Typography className={t("class-name-field-title")}>
            {t("thead_from_party")}
          </Typography>
          <IconButton sx={{ padding: 0.5 }} onClick={handleOpen}>
            <AddBoxOutlinedIcon
              fontSize="small"
              sx={{ color: "green", cursor: "pointer" }}
            />
          </IconButton>

          {open && (
            <PartyForm
              open={open}
              hideBackdrop={true}
              setRefetch={refetch}
              dialogTitle={"Create"}
              handleClose={handleClose}
            />
          )}
        </Stack>
      )}

      <Autocomplete
        disabled={disabled}
        fullWidth
        size="small"
        options={selectOptions}
        className={className}
        value={value}
        onChange={(_event, val) => onChange(val)}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={() => true}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("thead_select")}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </Stack>
  );
};



export const SelectReasonOfLossMember = ({
  className,
  onChange, 
  disabled = false,
  dialogTitle,
  value = { id: "", title: "" },
  helperText,
  error,
}) => {
  // Change Language
  const { language, t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_REASON_OF_LOSS_MEMBER_FOR_SELECT, {
    onCompleted: ({ getReasonOfLossMemberForSelect }) => {
      const data = getReasonOfLossMemberForSelect?.map((e) => ({
        id: e?._id,
        title: e?.reason_title,
      }));

      const defaultPosition = getReasonOfLossMemberForSelect.find((e) => e?.isDefault);
      if (dialogTitle === "Create" && defaultPosition?.isDefault) {
        onChange({
          id: defaultPosition?._id,
          title: defaultPosition?.reason_title,
        });
      }
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value]); 
  return (
    <Autocomplete
      disabled={disabled}
      fullWidth
      size="small"
      options={selectOptions}
      className={className}
      value={value}
      onChange={(_event, val) => onChange(val)}
      getOptionLabel={(option) => option.title || ""}
      isOptionEqualToValue={() => true}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={t("thead_select")}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};



export const SelectPartyForCopyCandidate = ({
  className,
  onChange,
  disabled = false,
  dialogTitle,
  value = { id: "", title: "" },
  helperText,
  error,
  mandateId
}) => {
  // Change Language
  const { language, t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_PARTY_FOR_COPY_CADIDATE, {
    variables: {
      mandateId: mandateId
    },
    onCompleted: ({ getPartyForCopyCandidate }) => {
      const data = getPartyForCopyCandidate?.map((e) => ({
        id: e?._id,
        title: e?.partyName,
      }));

      const defaultPosition = getPartyForCopyCandidate.find((e) => e?.isDefault);
      if (dialogTitle === "Create" && defaultPosition?.isDefault) {
        onChange({
          id: defaultPosition?._id,
          title: defaultPosition?.partyName,
        });
      }
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value]);


  return (
    <Autocomplete
      disabled={disabled}
      fullWidth
      size="small"
      options={selectOptions}
      className={className}
      value={value}
      onChange={(_event, val) => onChange(val)}
      getOptionLabel={(option) => option.title || ""}
      isOptionEqualToValue={() => true}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={t("thead_select")}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};



export const SelectProvince = ({
  className,
  onChange,
  error,
  dialogTitle,
  helperText,
  value,
}) => {
  // Change Language
  const { language, t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_CAPITAL_PROVINCE, {
    onCompleted: ({ getCapitalProvince }) => {
      const data = getCapitalProvince?.map((e) => ({
        id: e?._id,
        title:
          language === "en"
            ? e?.capital_province_name_en
            : e?.capital_province_name_kh,
      }));

      const defaultPosition = getCapitalProvince.find((e) => e?.isDefault);

      if (dialogTitle === "Create" && defaultPosition?.isDefault) {
        onChange({
          id: defaultPosition?._id,
          title:
            language === "en"
              ? defaultPosition?.capital_province_name_en
              : defaultPosition?.capital_province_name_kh,
        });
      }

      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value?.id]);

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={selectOptions}
      className={className}
      value={value}
      onChange={(_event, val) => onChange(val)}
      getOptionLabel={(option) => option.title || ""}
      isOptionEqualToValue={() => true}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={t("thead_select")}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export const SelectDistrict = ({
  className,
  onChange,
  error,
  dialogTitle,
  helperText,
  capicalProvincesId,
  value = { id: "", title: "" },
}) => {
  // Change Language
  const { language, t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);

  const { refetch } = useQuery(GET_DISTRICT_BY_PROVINCE, {
    variables: {
      capicalProvincesId: capicalProvincesId || "",
    },
    onCompleted: ({ getDistrictByProvice }) => {
      const data = getDistrictByProvice?.map((e) => ({
        id: e?._id,
        title:
          language === "en"
            ? e?.district_municipality_name_en
            : e?.district_municipality_name_kh,
      }));

      const defaultPosition = getDistrictByProvice.find((e) => e?.isDefault);

      if (dialogTitle === "Create" && defaultPosition?.isDefault) {
        onChange({
          id: defaultPosition?._id,
          title:
            language === "en"
              ? defaultPosition?.district_municipality_name_en
              : defaultPosition?.district_municipality_name_kh,
        });
      }

      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value, capicalProvincesId]);

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={selectOptions}
      className={className}
      value={value}
      onChange={(_event, val) => onChange(val)}
      getOptionLabel={(option) => option.title || ""}
      isOptionEqualToValue={() => true}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={t("thead_select")}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export const SelectCommune = ({
  className,
  onChange,
  error,
  helperText,
  districtMunicipalitiesId,
  value = { id: "", title: "" },
}) => {
  // Change Language
  const { language, t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_COMMUNE_BY_DISTRICT, {
    variables: {
      districtMunicipalitiesId: districtMunicipalitiesId || "",
    },
    onCompleted: ({ getCommuneByDistrict }) => {
      const data = getCommuneByDistrict?.map((e) => ({
        id: e?._id,
        title:
          language === "en"
            ? e?.commune_sangkat_name_en
            : e?.commune_sangkat_name_kh,
      }));
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value, districtMunicipalitiesId]);

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={selectOptions}
      className={className}
      value={value}
      onChange={(_event, val) => onChange(val)}
      getOptionLabel={(option) => option.title || ""}
      isOptionEqualToValue={() => true}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={t("thead_select")}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export const SelectVillage = ({
  className,
  onChange,
  communeSangkatId,
  error,
  helperText,
  value = { id: "", title: "" },
}) => {
  // Change Language
  const { language, t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_VILLAGE_BY_COMMUNE, {
    variables: {
      communeSangkatId: communeSangkatId || "",
    },
    onCompleted: ({ getVillageByCommune }) => {
      const data = getVillageByCommune?.map((e) => ({
        id: e?._id,
        title: language === "en" ? e?.village_name_en : e?.village_name_kh,
      }));
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [value, communeSangkatId]);

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={selectOptions}
      className={className}
      value={value}
      onChange={(_event, val) => onChange(val)}
      getOptionLabel={(option) => option.title || ""}
      isOptionEqualToValue={() => true}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={t("thead_select")}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export const SelectProvincailCouncilInMandate = ({
  className,
  onChange,
  helperText,
  valueSelected,
  required
}) => {

  // Change Language

  const { t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_PROVINCAIL_COUNCIL_IN_MANDATE_FOR_SELECT, {
    onCompleted: ({ getProvincailCouncilInMandateForSelect }) => {
    
      const data = getProvincailCouncilInMandateForSelect?.map((e) => ({
        id: e?.provincialCouncilInMandateId,
        title: e?.lastNameKh + " " + e?.firstNameKh,
      }));
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [valueSelected]);


  return (
    <Autocomplete
        fullWidth
        size="small"
        options={selectOptions}
        className={className}
        value={valueSelected}
        onChange={(_event, val) => onChange(val)}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={() => true}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("thead_select_provincail_council")}
            helperText={helperText}
            error={Boolean(required && !valueSelected?.id)}
          />
        )}
      />
  );
};

export const SelectSecretaryInMandate = ({
  className,
  onChange,
  helperText,
  valueSelected,
  required
}) => {

  // Change Language

  const { t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_SECRETARY_IN_MANDATE_FOR_SELECT, {
    onCompleted: ({ getSecretaryInMandateForSelect }) => {
      const data = getSecretaryInMandateForSelect?.map((e) => ({
        id: e?.secretaryInMandateId,
        title: e?.lastNameKh + " " + e?.firstNameKh ,
      }));
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [valueSelected]);


  return (
    <Autocomplete
        fullWidth
        size="small"
        options={selectOptions}
        className={className}
        value={valueSelected}
        onChange={(_event, val) => onChange(val)}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={() => true}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("thead_select_secretary")}
            helperText={helperText}
            error={Boolean(required && !valueSelected?.id)}
          />
        )}
      />
  );
};



export const SelectWorkGroup = ({
  className,
  onChange,
  helperText,
  valueSelected,
  required,
  error
  // touched,
  // errors
}) => {

  // Change Language

  const { t } = useContext(AuthContext);
  const [selectOptions, setSelectOptions] = useState([]);
  const { refetch } = useQuery(GET_WORK_GROUP_FOR_SELECT, {
    onCompleted: ({ getWorkGroupForSelect }) => {
      const data = getWorkGroupForSelect?.map((e) => ({
        id: e?._id,
        title: e?.numbering + ". " + e?.work_group_name ,
      }));
      setSelectOptions(data || []);
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [valueSelected]);

 
  return (
    <Autocomplete
        fullWidth
        size="small"
        options={selectOptions}
        className={className}
        value={valueSelected}
        onChange={(_event, val) => onChange(val)}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={() => true}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("thead_select_secretary")}
            error={error}
            
          />
        )}
      />
  );
};

